export default "__VITE_ASSET__CvbnolIL__"